import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Ticket } from 'src/app/models/ticket-models/ticket.model';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-tickets-tickets-breadcrumb-filter-card',
  templateUrl: './tickets-tickets-breadcrumb-filter-card.component.html',
  styleUrls: ['./tickets-tickets-breadcrumb-filter-card.component.scss']
})
export class TicketsTicketsBreadcrumbFilterCardComponent implements OnInit {

  // @Input() tickets;
  // centers;
  // centersForm = new FormGroup({});

  constructor(
    // private userStorageService: UserStorageService,
    // private ticketsService: TicketsService
    ) { }

  ngOnInit() {
    // this.getCenters();
    // if (this.userStorageService.getFilterTickets()) {
      // this.centersForm.patchValue(this.userStorageService.getFilterTickets()['centersForm']);
    // }
    // this.filter();
  }

  // public updateCheckbox(form, reset?) {
  //   this._toggleCheckboxes(form, reset);
  // }

  // private _toggleCheckboxes(form, reset) {
  //   if (reset && form.get('all').value) {
  //     Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
  //   } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
  //     form.get('all').setValue(false);
  //   } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
  //     form.get('all').setValue(true);
  //   }
  //   // this.userStorageService.setFilterTickets({ centersForm: this.centersForm.getRawValue() });
  //   // if (this.userStorageService.getFilterTickets()['centersForm']['all']) {
  //   //   this.userStorageService.deleteFilterTickets();
  //   // }
  //   this.filter();
  // }

  // private getCenters() {
  //   const centers = new Array<string>();
  //   this.centersForm.addControl('all', new FormControl(true));
  //   this.tickets.forEach((d: Ticket) => {
  //     if (centers.indexOf(d.CenterName) === -1) {
  //       centers.push(d.CenterName);
  //       this.centersForm.addControl(d.CenterName, new FormControl(false));
  //     }
  //   });
  //   this.centers = centers;
  // }

  // public filter() {
    // const forms = {
    //   centersForm:
    //   {
    //     attribute: 'CenterName',
    //     values: []
    //   }
    // };
    // if (this.centersForm.get('all').value) {
    //   forms['centersForm'].values = Object.keys(this.centersForm.value).splice(1);
    // } else {
    //   Object.entries(this.centersForm.value).forEach(c => { if (c[1]) { forms['centersForm'].values.push(c[0]); }});
    // }
    // this.ticketsService.filterTickets(forms);
  // }
}
